export default "__VITE_ASSET__me0EFTGZ__"